import React from "react";
import styled from "styled-components";

import { Button } from "../components/Button";
import { Flex } from "../components/Flex";
import { Rounded } from "../theme/Rounded";
import { Shadow } from "../theme/Shadow";
import { Spacing } from "../theme/Spacing";
import { faXmark } from "@fortawesome/free-solid-svg-icons/faXmark";

const Container = styled(Flex)<{
  visible: boolean;
}>`
  width: 100%;
  gap: ${Spacing.m};
  transition: all 0.5s ease;
  opacity: ${({ visible }) => (visible ? 1 : 0)};
  visibility: ${({ visible }) => (visible ? "visible" : "hidden")};
`;

const BannerJSX = styled(Flex)<{ visible: boolean }>`
  width: 100%;
  box-shadow: ${Shadow.MD};
  position: relative;
`;

const ContentWrapper = styled(Flex)`
  flex-direction: column;
  justify-content: center;
  width: 100%;
  height: 100%;
  align-items: center;
  margin: auto;
  padding: ${Spacing.s} ${Spacing.l};
  gap: ${Spacing.m};
  position: relative;
  overflow: hidden;
  background: ${({ theme }) => theme.darkMain}fe;
  border: ${({ theme }) => `1px solid ${theme.sub}22`};

  &::before {
    content: "";
    position: absolute;
    top: -40%;
    left: -10%;
    width: 130%;
    height: 80%;
    background: linear-gradient(
      120deg,
      rgba(255, 255, 255, 0.22) 0%,
      rgba(255, 255, 255, 0.04) 60%
    );
    transform: rotate(8deg);
    border-radius: inherit;
    pointer-events: none;
  }
`;

const CloseButton = styled(Button)`
  margin: 0;
  padding: 0;
  background-color: ${({ theme }) => theme.transparent};
  color: ${({ theme }) => theme.sub};
  border-radius: ${Rounded.circle};
  position: absolute;
  top: ${Spacing.s};
  inset-inline-end: ${Spacing.m};
  z-index: 5;

  &:hover {
    color: ${({ theme }) => theme.lightSub};
  }
`;

type Props = {
  open: boolean;
  onClose?: VoidFunction;
  children?: React.ReactNode;
  className?: string;
  closeButtonDisabled?: boolean;
};

export const Banner: React.FC<Props> = ({
  open,
  onClose,
  children,
  className,
  closeButtonDisabled = false,
}) => {
  if (!open) {
    return null;
  }

  return (
    <Container visible={open} className={className}>
      <BannerJSX visible={open}>
        {onClose ? (
          <CloseButton
            onClick={onClose}
            disabled={closeButtonDisabled}
            icon={faXmark}
            iconWidth="lg"
          />
        ) : null}

        <ContentWrapper className="atira-banner-content-wrapper">
          {children}
        </ContentWrapper>
      </BannerJSX>
    </Container>
  );
};
